export enum Spannungsebene {
    HOECHST_SPANNUNG = 'HOECHST_SPANNUNG',
    HOCH_SPANNUNG = 'HOCH_SPANNUNG',
    MITTEL_SPANNUNG = 'MITTEL_SPANNUNG',
    NIEDER_SPANNUNG = 'NIEDER_SPANNUNG'
}

export class SpannungsebeneItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): SpannungsebeneItem[] {
        return [
            new SpannungsebeneItem(Spannungsebene.HOECHST_SPANNUNG, 'Höchstspannung'),
            new SpannungsebeneItem(Spannungsebene.HOCH_SPANNUNG , 'Hochspannung'),
            new SpannungsebeneItem(Spannungsebene.MITTEL_SPANNUNG , 'Mittelspannung'),
            new SpannungsebeneItem(Spannungsebene.NIEDER_SPANNUNG , 'Niederspannung'),
        ];
    }

}

